import { useAuthQuery } from 'features/common/apiUtils/queryHelper';
import { auditLogsApi } from '../api/endpoints';
import { AuditLogsResponse } from '../types';
import { AuditLogsSupportedSystemName } from '../constants';
import { AxiosResponse } from 'axios';

export const useGetLogs = ({
  onSuccess,
  onError,
  system,
  continuationToken,
  tenantId,
}: {
  onSuccess: (data: AxiosResponse<AuditLogsResponse>) => void;
  onError: () => void;
  system: AuditLogsSupportedSystemName;
  continuationToken: string;
  tenantId?: string;
}) => {
  const { get_logs } = auditLogsApi;
  const url = get_logs.url({
    system,
    continuationToken,
    tenantId,
  });

  return useAuthQuery(
    [url],
    async (axiosInstance) => {
      return axiosInstance?.get<AuditLogsResponse>(url);
    },
    { onSuccess, onError },
    get_logs.scope,
  );
};
